/**
 * 🎨 Store de Preferências de UI (com Persist seguro)
 * 
 * Persiste preferências não-sensíveis do usuário:
 * - Modo preferido (teacher/family/student)
 * - Tema
 * - Outras preferências de UI
 * 
 * ✅ Seguro: Não contém dados sensíveis de autenticação
 * ✅ Cross-tab: Sincroniza entre abas
 * ✅ Resiliente: Sobrevive a refresh do navegador
 */

import { create } from 'zustand';
import { persist } from 'zustand/middleware';

type ViewMode = 'teacher' | 'family' | 'student' | 'admin';

interface PreferencesState {
  preferredMode: ViewMode | null;
  setPreferredMode: (mode: ViewMode | null) => void;
  theme: 'light' | 'dark' | 'system';
  setTheme: (theme: 'light' | 'dark' | 'system') => void;
}

export const usePreferencesStore = create<PreferencesState>()(
  persist(
    (set) => ({
      preferredMode: null,
      theme: 'system',
      
      setPreferredMode: (mode) => set({ preferredMode: mode }),
      setTheme: (theme) => set({ theme }),
    }),
    {
      name: 'auli-preferences',
    }
  )
);

// Selector hooks para performance
export const usePreferredMode = () => usePreferencesStore((state) => state.preferredMode);
export const useTheme = () => usePreferencesStore((state) => state.theme);
